<template>
  <div class="container p-16px">
    <div class="panel" style="position: relative">
      <div :class="isMobile ? 'm-body' : 'body'">
        <div class="pic">
          <img src="@/assets/img/success.svg" width="35" />
        </div>
        <div class="title">
          <span>{{ $t('注册成功') }}</span>
        </div>
        <div class="tip">
          <span>{{ $t('温馨提示：实名认证后可进行产品购买') }}</span>
        </div>
        <div :class="isMobile ? 'mobileBtn' : ''">
          <el-button
            clstag="jdcloud-login|keycount|register|certification"
            :class="[{ 'mt-24px': !isMobile }, 'verifyBtn']"
            @click="goVerify"
            >{{ $t('立即实名认证') }}</el-button
          >
          <el-button
            clstag="jdcloud-login|keycount|register|return"
            :class="[{ 'mt-16px': !isMobile }, 'backBtn']"
            @click="goBack"
            >{{ $t('返回') }}</el-button
          >
        </div>
        <div :class="{ 'enterprise-wechat-box': !isMobile }">
          <enterprise-we-chat-code />
        </div>
      </div>
      <div>
        <newUserRecommend />
      </div>
    </div>
  </div>
</template>
<script>
import newUserRecommend from '@/components/newUserRecommend.vue'
import EnterpriseWeChatCode from '../../components/EnterpriseWeChatCode.vue'
import { useReturnUrl } from '@/hooks'
export default {
  components: { EnterpriseWeChatCode, newUserRecommend },
  mounted() {
    const script = document.createElement('script')
    script.src = '//img1.jcloudcs.com/ytk/jdcloud-ytk.js'
    script.async = true
    document.head.appendChild(script)
  },
  methods: {
    goBack() {
      const { returnUrl } = useReturnUrl()
      window.location = decodeURIComponent(returnUrl) || derivativeConfig.consoleUrl
    },
    goVerify() {
      const link = derivativeConfig.verify
      window.open(link)
    }
  }
}
</script>
<style scoped>
.enterprise-wechat-box {
  position: absolute;
  right: 0;
  top: 0;
}
.p-16px {
  padding: 16px;
}
.mt-24px {
  margin-top: 24px;
}
.mt-16px {
  margin-top: 16px;
}
.body {
  width: 360px;
  margin: auto;
  text-align: center;
  margin-bottom: 16px;
  padding-bottom: 24px;
}
.pic {
  width: 35px;
  margin: 0 auto;
  margin-top: 63px;
}
.title {
  margin-top: 20px;
  height: 28px;
  line-height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.tip {
  margin-top: 8px;
  height: 17px;
  line-height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  color: rgba(0, 0, 0, 0.45);
}
.verifyBtn {
  width: 360px;
  height: 40px;
  background: rgba(225, 37, 27, 1);
  border-radius: 2px;
  color: rgba(255, 255, 255, 1);
}
.backBtn {
  width: 360px;
  height: 40px;
  border: 1px solid rgba(225, 37, 27, 1);
  border-radius: 2px;
  color: rgba(225, 37, 27, 1);
  margin-left: 0;
  background: rgba(255, 255, 255, 1);
}
@media only screen and (max-width: 640px) {
  .m-body {
    margin: auto;
    padding: 16px;
    text-align: center;
    padding-bottom: 16px;
  }
  .mobileBtn {
    display: flex;
    margin: 16px 0;
  }
  .pic {
    margin-top: 35px;
  }
  .backBtn {
    width: 360px;
    height: 40px;
    border: 1px solid rgba(225, 37, 27, 1);
    border-radius: 2px;
    color: rgba(225, 37, 27, 1);
    margin-left: 8px;
  }
}
</style>
